import { Api } from "./Api.class";
const endpoint = "people";
const peopleAPI = new Api(endpoint);
export default peopleAPI;
